import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Paper, Tabs } from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';

import { LargeTab, Queries, PaddedPaper } from 'components';
import * as paths from 'paths';
import * as Links from 'Links';

import { DepartmentsLocations, Disclosures, Information, Policies } from '../components/Account';
import { EditableListType } from '../types';

const Account: FC = () => {
  const match = useRouteMatch();
  const { t } = useTranslation();

  const isDepartments = match.path === paths.adminSettingsDepartments;
  const isLocations = match.path === paths.adminSettingsLocations;
  const isDisclosures = match.path === paths.adminSettingsDisclosures;
  const isPolicies = match.path === paths.adminSettingsPolicies;

  return (
    <Grid container direction="column" spacing={4}>
      <Grid item xs>
        <PaddedPaper>
          <Information />
        </PaddedPaper>
      </Grid>
      <Grid item xs>
        <Paper>
          <Tabs value={match.path}>
            <LargeTab
              component={Links.AdminSettingsDepartments}
              label={t('admin:departments')}
              value={paths.adminSettingsDepartments}
            />
            <LargeTab
              component={Links.AdminSettingsLocations}
              label={t('admin:locations')}
              value={paths.adminSettingsLocations}
            />
            <LargeTab
              component={Links.AdminSettingsDisclosures}
              label={t('admin:disclosures')}
              value={paths.adminSettingsDisclosures}
            />
            <LargeTab
              component={Links.AdminSettingsPolicies}
              label={t('admin:policies')}
              value={paths.adminSettingsPolicies}
            />
          </Tabs>
          <Grid>
            <PaddedPaper padding={40}>
              {isDepartments && (
                <Queries.GetClientDepartments>
                  {({ client_departments }) => (
                    <DepartmentsLocations
                      list={client_departments}
                      listType={EditableListType.Departments}
                    />
                  )}
                </Queries.GetClientDepartments>
              )}
              {isLocations && (
                <Queries.GetClientLocations>
                  {({ client_locations }) => (
                    <DepartmentsLocations
                      list={client_locations}
                      listType={EditableListType.Locations}
                    />
                  )}
                </Queries.GetClientLocations>
              )}
              {isDisclosures && (
                <Queries.GetAllClientDisclosures>
                  {({ client_disclosures }) => <Disclosures list={client_disclosures} />}
                </Queries.GetAllClientDisclosures>
              )}
              {isPolicies && <Policies />}
            </PaddedPaper>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Account;
